import React from "react";

export default function Annexure2(props) {
  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-3xl font-bold mb-6 text-yellow-500">
          Good Practices (Always Adopt – Do’s)
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-yellow-500">Annexure-2</h2>
      </div>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <ul className="space-y-4 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Be visible when working with children. Work in an open
                environment (e.g. avoid private or unobserved situations and
                encourage open communication with no secrets).
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Treat all children including disabled children equally, with
                respect and dignity.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Put the welfare of each child first, before winning or achieving
                goals.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Maintain a safe and appropriate distance with children to avoid
                discomfort to the child
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Build a working relationship based on mutual trust which
                empowers children to share or report the cases of abuse.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Take extra care when manual or physical contact is required when
                the child is on field or in changing rooms. Children and their
                parents should always be consulted and their agreement obtained.
                Wherever possible, involve parents/ carers. For example,
                encourage them to take responsibility for their children in the
                changing rooms.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that when the mixed teams are travelling, they should
                always be supervised by a male and female member of
                staff/coaches/volunteers. However, remember that same gender
                abuse can also occur.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure being an excellent role model - this includes not
                smoking, chewing tobacco or drinking alcohol, using obscene/
                unparliamentary language and observing safety and traffic rules
                in the company of children. Adults working with children should
                dress appropriately for the task undertaken.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Give enthusiastic and constructive feedback rather than negative
                criticism.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Secure parental/guardian’s consent in writing (a) to act in loco
                parentis, if the need arises to administer emergency first aid
                and/or other medical treatment. (b)to transport children in
                vehicles of SS/KVS officials, if such a need arises (c) to take
                and use for publication/ social media any photos/ videos of
                children during programme activities/events
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Listen to and respect children, empower them and let them
                participate in planning and delivering activities as much as
                possible
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Report any concerns you may have about the protection or
                well-being of child/children to the CPO of SS/KVS. Observe
                confidentiality and do not talk about any situations of actual
                or suspected abuse that occurs except in accordance with this
                policy. This is necessary to protect the privacy of those
                involved
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Work to prevent and promptly address bullying among program
                participants, as part of creating a safe environment
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Recognize and gauge the developmental needs and capacity of
                children and including disabled children. Ensure that rigors of
                training/ activity do not exceed the capacity of the
                participants.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Guidelines on Managing Behavior
          </h2>
          <ul className="space-y-2 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Set clear expectations</b>: Clearly define your expectations for
                children’s behaviour, and communicate them in a way that is easy
                for them to understand.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Reinforce positive/good behaviour</b>: Praise children when they
                behave well, and recognize their efforts to behave
                appropriately.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Encourage self-reflection</b>: Encourage children to reflect on
                their own bad/ erratic behaviour
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Redirect</b>: If children are engaging in inappropriate behaviour,
                redirect them to a more appropriate activity.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Use positive languag</b>e: Use positive language when communicating
                with children.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Sit with children and talk about their behaviour in a calm and
                supportive way
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
